import React from 'react'
import {Modal} from 'common/modals'
import {Button} from 'common/buttons'
import {useState} from 'hooks'

/**
 * Generic confirmation ("security") dialog for destructive actions. The caller
 * passes `onConfirm` (may be async); the modal disables while it runs and closes
 * afterwards. Defaults to a danger (red) confirm button.
 */
export function ConfirmModal(props: any)
{
	const {
		title = 'Are you sure?',
		message,
		confirmLabel = 'Confirm',
		cancelLabel = 'Cancel',
		variant = 'danger',
		onConfirm,
		close,
	} = props

	const [busy, setBusy] = useState(false)

	const handleConfirm = async () => {
		setBusy(true)
		try {
			await onConfirm?.()
			close()
		} catch (error) {
			console.log(error)
			setBusy(false)
		}
	}

	return (
		<Modal {...props}>
			<div className="modal-body">
				<h2 className="mb-2">{title}</h2>
				{message && <p className="text-muted mb-0">{message}</p>}
			</div>
			<div className="modal-footer">
				<Button variant="outline-secondary" disabled={busy} onClick={close}>
					{cancelLabel}
				</Button>
				<Button variant={`outline-${variant}`} disabled={busy} onClick={handleConfirm}>
					{confirmLabel}
				</Button>
			</div>
		</Modal>
	)
}
